/**
 * Parcels
 */

// React
import React, { FunctionComponent, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

// Components
import Pagination from '@material-ui/lab/Pagination';
import List from './components/listMob';

import RenderFilter from '../../utils/listDaynamicFilterHookFormMob';
import { useForm } from 'react-hook-form';

// UI
import theme from '../../theme';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  DialogTitle,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Paper,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiArrowRight,
  mdiCheck,
  mdiClose,
  mdiMapMarkerOutline,
  mdiKeyOutline,
  mdiStateMachine,
  mdiHomeOutline,
} from '@mdi/js';

// Helper
import { removeEmptyValueObject } from '../../utils/helpers';

// Type
import { Props } from './interfaces';
import type { Filter } from '../../utils/listDaynamicFilter';
import parcelsRepository from 'client-sdk/src/Repository/parcels-repository';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotification';
import useQuery from '../../utils/hook/useQuery';

type Inputs = {
  'id.equals': string;
};

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '30px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    secondDetail: {
      backgroundColor: 'white',
      padding: '5px',
      borderRadius: '5px',
      // width: '100%',
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    tileBar: {
      zIndex: 10,
      position: 'fixed',
      top: '0px',
      right: '0px',
      display: 'flex',
      width: '100%',
      padding: '8px',
    },
    tabs: {
      zIndex: 12,
      boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.08)',
      position: 'fixed',
      top: '52px',
      right: 0,
      borderBottom: 1,
      borderColor: '#000',
      width: '100%',
      backgroundColor: '#fff',

    },
  })
);

const Parcels: FunctionComponent<Props> = (props: Props) => {
  const { } = useForm<Inputs>({
    defaultValues: {
      idType: '',
    },
  });
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 20,
    'status.in': 'ASSIGNED,REGISTERED',
  } as any);
  const [filters, setFilters] = useState([] as Filter[]);
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [openDialog, setOpenDialog] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const [openConfirmActive, setOpenConfirmActive] = useState(false as boolean);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [loading, setLoading] = useState<boolean>(false);
  const [parcelsList, setParcelsList] = useState([]);
  const [count, setCount] = useState<number>(0);
  const removeFilterHandler = (fieldName: any) => {
    const filtered = { ...filtersValues };
    delete filtered[fieldName];
    setFiltersValues(filtered);
  };
  const filterTranslator = (fieldName: string) => {
    const status = {
      customerName: 'نام سفارش دهنده',
      'customerName.equals': 'نام سفارش دهنده:',
      'customerName.contais': 'نام سفارش دهنده:',
      trackingCode: 'کد پیگیری',
      'trackingCode.equals': 'کد پیگیری',
      'trackingCode.contains': 'کد پیگیری',
      'id.equals': 'شناسه سفارش:',
      'id.contains': 'شناسه سفارش:',
      deliveryDate: 'زمان تحویل',
      'deliveryDate.equals': 'زمان تحویل:',
      'deliveryDate.contains': 'زمان تحویل:',
      status: 'وضعیت سفارش',
      'status.in': 'وضعیت سفارش:',
      'status.notIn': 'وضعیت سفارش:',
    };
    return status[fieldName];
  };
  useEffect(() => {
    getParcels();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps
  const classes = useStyles();
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };
  const getParcel = async (action: any) => {
    const payload = { ...action };
    try {
      setLoading(true);
      const { response, count } = await parcelsRepository.getParcels({ payload });
      setCount(count.data);
      setParcelsList(response.data);
      // switch (response.data[0]?.status) {
      //   case 'REGISTERED':
      //     props.history.push(`/parcels-mob/details/${response.data[0].id}`)
      //     break;
      // }
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const getParcels = () => {
    const { page, size } = filtersValues;
    getParcel({
      ...removeEmptyValueObject(filtersValues),
      page,
      size,
    });
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };
  const handleClose = () => {
    setOpenConfirmDisable(false);
    setOpenDialog(false);
    setOpenConfirmActive(false);
    setOpenSize(false);
  };

  const handleOpenConfirmUpdateState = (data: { id: number; body: any }) => {
    setId(data.id);
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'sourceWarehouseName.contains',
        label: 'مبدا',
        icon: mdiMapMarkerOutline,
      },
      {
        type: 'input',
        id: 'id.equals',
        label: 'شناسه محموله ',
        icon: mdiKeyOutline,
      },
      {
        type: 'checkbox',
        id: 'status.in',
        label: 'وضعیت محموله',
        data: ['ASSIGNED', 'REGISTERED'],
        translateType: 'ParcelsStatus',
        icon: mdiStateMachine,
      },
    ]);
  };
  let headCells = [];
  headCells = [
    {
      id: 'sourceWarehouseName',
      type: 'input',
      label: 'مبدا',
    },
    {
      id: 'destinationWarehouseName',
      type: 'input',
      label: 'مقصد',
    },
    {
      id: 'id',
      type: 'input',
      label: 'شناسه محموله',
    },
    {
      id: 'shippingDate',
      type: 'date-picker',
      label: 'تاریخ ثبت',
    },
    {
      id: 'deliveryDate',
      type: 'date-picker',
      label: 'تاریخ تحویل',
    },
    {
      id: 'items',
      type: 'input',
      label: 'تعدادکارتن',
    },
    {
      id: 'status',
      label: 'وضعیت',
      translate: 'ParcelsStatus',
      type: 'checkbox',
      data: ['ASSIGNED', 'REGISTERED'],
      translateType: 'ParcelsStatus',
      filter: 'not'
    },
  ];
  const head = { headCells };
  const updateParcelsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await parcelsRepository.updateParcelStatus({ payload });
      handleNotfication('محموله با موفقیت به روز رسانی شد', 'success');
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };

  const handleDisableUser = async () => {
    await updateParcelsStatus({
      id,
      body: 'CANCELLED'.replace(/'/g, '"'),
      pagination: filtersValues,
    });
    setOpenConfirmDisable(false);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid container>
          <Paper
            className={classes.tileBar}
          >
            <Grid container xs={12} justifyContent={'center'} alignContent={'center'}>
              <Typography variant="h6" component="h2">
                {'لیست محموله‌ها '}
              </Typography>

            </Grid>
            <span >
              <Link to={'/mobile-home'} style={{ justifySelf: 'right' }}>
                <Icon path={mdiHomeOutline} size={1.2} color={'black'} />
              </Link>
            </span>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <RenderFilter
            filters={filters}
            onFilter={(filtervalues: any) => {
              setFiltersValues({
                ...removeEmptyValueObject(filtervalues),
                page: 0,
                size: 20,
                'status.in': 'ASSIGNED,REGISTERED',
              });
            }}
            mainFiltersCount={1}
            baseFilter={{
              type: 'input',
              id: 'id.equals',
              placeholder: 'شناسه محموله',
            }}
            filterValues={filtersValues}

            name={'محموله ها'}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          {loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              {parcelsList.length > 0 ? (
                <List
                  data={parcelsList}
                  handleOpenConfirmUpdateState={
                    handleOpenConfirmUpdateState
                  }
                  head={head}
                  filterVal={filtersValues}
                  onFilterValue={(filtervalues: any) => {
                    setFiltersValues({
                      ...removeEmptyValueObject(filtervalues),
                      ...filtersValues,
                      page: 0,
                      size: 10,
                    });
                  }}
                  removeFilterHandler={removeFilterHandler}
                  filterLabelTranslator={filterTranslator}
                />
              ) : (
                <Typography variant="h3" component="div">
                  سفارشی موجود نیست
                </Typography>
              )}
            </>
          )}
        </Grid>
        <span style={{ position: 'fixed', bottom: 10, }}>
          <Grid item xs={12} sm={6}>
            {parcelsList.length > 0 && (
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    marginLeft: '10px',
                    color: '#8a8a8a',
                  }}
                >
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSize}
                  onClose={handleClose}
                  onOpen={() => setOpenSize(true)}
                  value={filtersValues.size}
                  onChange={handleChangeSizePage}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            )}
          </Grid>
          <Grid xs={12} sm={6} container item direction="row-reverse">
            {parcelsList.length > 0 && (
              <Pagination
                className={classes.pagination}
                count={Math.ceil(count / filtersValues.size)}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
            )}
          </Grid>
        </span>

      </Grid>
      {/* <Grid container spacing={3}>
        <Grid item xs={12}>
          {loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              {parcelsList.length > 0 ? (
                <Helper
                  removeFilterHandler={removeFilterHandler}
                  sizeChanged={sizeChangeHandler}
                  pageChanged={pageChangeHandler}
                  count={count}
                  data={parcelsList}
                  head={head}
                  filterVal={filtersValues}
                  onFilterValue={(filtervalues: any) => {
                    setFiltersValues({
                      ...removeEmptyValueObject(filtervalues),
                      ...filtersValues,
                      page: 0,
                      size: 10,
                    });
                  }}
                  filterLabelTranslator={filterTranslator}
                  changeStatus={handleOpenConfirmUpdateState}
                  setSelectedId={setSelectedId}
                >
                  {(row: any) => {
                    return (
                      <Fragment>
                        {row.status === 'ASSIGNED' ? (
                          <Link to={`/parcel/${row.id}/unload-inventory-items`}>
                            <IconButton size="small" title="تخلیه محموله">
                              <Icon
                                color={theme.palette.orange.main}
                                path={mdiPackageDown}
                                size={1}
                              />
                            </IconButton>
                          </Link>
                        ) : null}
                        {row.status === 'UNLOADED' ? (
                          <Link to={`/parcel/${row.id}/inventory-items`}>
                            <IconButton size="small" title="تطبیق محموله">
                              <Icon
                                color={theme.palette.blue.main}
                                path={mdiPlaylistCheck}
                                size={1}
                              />
                            </IconButton>
                          </Link>
                        ) : null}
                        {row.status === 'REGISTERED' ? (
                          <Link to={`/parcel/${row.id}/locate-inventory-items`}>
                            <IconButton size="small" title="جایگذاری محموله">
                              <Icon color="purple" path={mdiFileTree} size={1} />
                            </IconButton>
                          </Link>
                        ) : null}
                        <Link to={`/parcels/details/${row.id}`}>
                          <IconButton
                            aria-label="details"
                            size="small"
                            title="جزئیات محموله"
                            data-cy="details"
                          >
                            <Icon
                              path={mdiFileDocumentOutline}
                              size={1}
                              color={theme.palette.green.main}
                            />
                          </IconButton>
                        </Link>
                        <Link to={`/parcels/${row.id}/allLogs`}>
                          <IconButton size="small" title="تاریخچه محموله">
                            <Icon path={mdiHistory} size={1} />
                          </IconButton>
                        </Link>
                      </Fragment>
                    );
                  }}
                </Helper>
              ) : (
                <Typography variant="h3" component="div">
                  محموله موجود نیست
                </Typography>
              )}
            </>
          )}
        </Grid>

      </Grid> */}


      <Dialog
        fullScreen
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          {/* <div>{`
      گزارش موجودی انبار
        "${props.parcelsList.find(item => item.id === id)?.name}"
        `}</div> */}
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <Icon path={mdiArrowRight} size={1} />
            {'بازگشت'}
          </Button>
        </DialogTitle>
        <DialogContent>
          {/* {type === 'edit' && (
            <Edit
              data={props.parcelsList.find(item => item.id === id)}
              partnerId={props.match.params.id}
              update={body => {
                props.updateParcelsDispatch({
                  body,
                  pagination: filtersValues,
                  id: props.match.params.id,
                });
                handleClose();
              }}
            />
          )} */}
        </DialogContent>
      </Dialog>

      <Dialog
        fullWidth
        open={openConfirmDisable || openConfirmActive}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div
            className={
              openConfirmDisable ? classes.cancelIcon : classes.editIcon
            }
          >
            {openConfirmDisable ? (
              <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
            ) : (
              <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
            )}
          </div>
          <div className={classes.cancelTitle}>
            {` از 
            
            لغو محموله با شناسه
          "${parcelsList.find(item => item.id === id)?.id}"
          مطمئن هستید؟`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={handleDisableUser}
                fullWidth
                variant="contained"
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Parcels;
